import MapPinned from "lucide-react/dist/esm/icons/map-pinned";
import EditorialImage from "@/components/EditorialImage";
import Reveal from "@/components/Reveal";

const places = ["Müllheim", "Markgräflerland", "umliegende Orte", "nach Absprache"];

export default function RegionSection() {
  return (
    <section className="section region-section" id="einsatzgebiet" data-testid="regional-coverage-container">
      <div className="container region-grid">
        <Reveal className="region-visual">
          <EditorialImage
            src="https://images.unsplash.com/photo-1563514227147-6d2ff665a6a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHx2aW5leWFyZCUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3ODgxOTQ2MjN8MA&ixlib=rb-4.1.0&q=85"
            alt="Sonnenbeschienene Rebhänge und sanfte Weinberge im Markgräflerland bei Müllheim"
            label="MÜLLHEIM & MARKGRÄFLERLAND"
            testId="region-image"
            loading="eager"
            className="region-image"
          />
        </Reveal>
        <Reveal className="region-copy" delay={100}>
          <span className="eyebrow">Einsatzgebiet · 05 / 05</span>
          <h2 className="section-title">Nah dran,<br /><em>wenn Sie uns brauchen.</em></h2>
          <p className="section-lead">Unser Schwerpunkt liegt in Müllheim im Markgräflerland und den umliegenden Orten. Für Ihre Anfrage zählt zuerst, was konkret gebraucht wird.</p>
          <div className="place-list">
            {places.map((place, index) => <span key={place} data-testid={`region-chip-${index + 1}`}><MapPinned size={15} />{place}</span>)}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
